import { render, staticRenderFns } from "./ERP.vue?vue&type=template&id=f1436710&scoped=true"
import script from "./ERP.vue?vue&type=script&lang=js"
export * from "./ERP.vue?vue&type=script&lang=js"
import style0 from "./ERP.vue?vue&type=style&index=0&id=f1436710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1436710",
  null
  
)

export default component.exports